// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d95532b7","64":"0ee99cd0","337":"48270522","557":"626cac56"}[chunkId] + ".chunk.js";
};